var _ellipse, _path, _rect, _rect2, _path2, _rect3, _rect4, _path3, _rect5, _rect6, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyGridPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 139,
    viewBox: "0 0 156 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.7965,
    cy: 69.1967,
    rx: 70.7965,
    ry: 69.1967,
    fill: "url(#paint0_linear_2292_247069)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73048 22.8387C17.1799 1.31749 44.8697 -1.55457 69.1428 0.593569C84.9436 1.99192 100.174 7.40068 112.985 15.6184L128.657 40.9453C128.883 41.3108 129.028 41.7207 129.082 42.1471L134 81L127.186 105.983C127.186 105.983 120.645 118.867 94.225 130.584C67.8045 142.301 41.6071 140.636 17.546 122.888C-6.51508 105.14 -1.71892 44.3599 7.73048 22.8387Z",
    fill: "#E2EBF3"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 17,
    width: 124,
    height: 31,
    rx: 4,
    fill: "#B1BCC4",
    fillOpacity: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 15.5,
    width: 123,
    height: 30,
    rx: 3.5,
    fill: "url(#paint1_linear_2292_247069)",
    stroke: "#D5DDE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30.5H139",
    stroke: "#C9D2D8",
    strokeOpacity: 0.5,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 52,
    width: 124,
    height: 31,
    rx: 4,
    fill: "#B1BCC4",
    fillOpacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 50.5,
    width: 123,
    height: 30,
    rx: 3.5,
    fill: "url(#paint2_linear_2292_247069)",
    stroke: "#D5DDE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 65.5H139",
    stroke: "#C9D2D8",
    strokeOpacity: 0.5,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 87,
    width: 124,
    height: 31,
    rx: 4,
    fill: "#B1BCC4",
    fillOpacity: 0.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 85.5,
    width: 123,
    height: 30,
    rx: 3.5,
    fill: "url(#paint3_linear_2292_247069)",
    stroke: "#D5DDE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 100.5H139",
    stroke: "#C9D2D8",
    strokeOpacity: 0.5,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2292_247069",
    x1: 73.4341,
    y1: 191.569,
    x2: 205.051,
    y2: 87.8958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2292_247069",
    x1: 32.5,
    y1: 15,
    x2: 156,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2292_247069",
    x1: 32.5,
    y1: 50,
    x2: 156,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2292_247069",
    x1: 32.5,
    y1: 85,
    x2: 156,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGridPlaceholder);
export default __webpack_public_path__ + "static/media/empty-grid-placeholder.a9fb05bbe6439021abf8aec85046b402.svg";
export { ForwardRef as ReactComponent };